import { createContext } from "react"

const QuickQuoteContext = createContext({})

const { Provider, Consumer } = QuickQuoteContext

export { Provider, Consumer, QuickQuoteContext }
